import cn from "classnames";
import portraitplaceholderDark from "assets/placeholder-dark.svg";
import portraitplaceholder from "assets/placeholder.svg";
import { ComponentPropsWithRef, FC } from "react";
import { useUI } from "state/UIContext";

type ImageProps = ComponentPropsWithRef<"img">

type Props = {
  src?: string,
  alt?: string
  className?: string
  placeholder?: string
} & ImageProps


const Avatar: FC<Props> = ({
  src,
  alt,
  className,
  placeholder = portraitplaceholder,
  ...rest
}) => {
  const { colorScheme } = useUI();
  return (
    <>
      <img
        className={cn("w-full h-full", className)}
        src={src || (colorScheme === "light"? portraitplaceholder
        : portraitplaceholderDark)}
        alt={alt}
        {...rest}
      />
    </>
  );
};

export default Avatar;
